import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Introduction() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/martbook/intro_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={983}
              height={983}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto  offset-lg-1 order-md-2 order-1"
          >
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#259354" }}>Introduction</span>
            </h2>
            <p>
              Mart Book app is the more convenient option for farmers to explore
              regional markets and buy or sell animals of their choice in just
              three simple steps. Mart Book app is a step ahead of its time, it
              helps farmers to catch up with fast-paced dynamics and changing
              trends of the business world.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Introduction;
